import { StateMachine } from "@/core/arch/state_machine";
import { ProvisioningRepository } from "./provisioning_repository";
import type { ProvisioningRequest } from "./types";

interface DashboardState {
  loading: boolean;
  error: string | null;
  todayCount: number;
  weekCount: number;
  failedCount: number;
  totalCount: number;
  failedItems: ProvisioningRequest[];
  recentItems: ProvisioningRequest[];
}

const initialState: DashboardState = {
  loading: false,
  error: null,
  todayCount: 0,
  weekCount: 0,
  failedCount: 0,
  totalCount: 0,
  failedItems: [],
  recentItems: [],
};

export class DashboardBloc extends StateMachine<DashboardState> {
  constructor(private repo: ProvisioningRepository) {
    super(initialState);
  }

  async load(): Promise<void> {
    this.setState({ ...this.state, loading: true, error: null });
    try {
      const items = await this.repo.list();
      const now = new Date();
      const todayStart = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
      );
      const weekStart = new Date(todayStart);
      weekStart.setDate(weekStart.getDate() - weekStart.getDay());

      const sorted = items.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );

      this.setState({
        ...this.state,
        loading: false,
        totalCount: items.length,
        todayCount: items.filter((i) => new Date(i.createdAt) >= todayStart)
          .length,
        weekCount: items.filter((i) => new Date(i.createdAt) >= weekStart)
          .length,
        failedCount: items.filter((i) => i.status === "failed").length,
        failedItems: sorted.filter((i) => i.status === "failed").slice(0, 10),
        recentItems: sorted.slice(0, 10),
      });
    } catch (error) {
      this.setState({
        ...this.state,
        loading: false,
        error: error instanceof Error ? error.message : "Failed to load",
      });
    }
  }
}
